import React from 'react';
import { Nullable } from 'global';
import { formatCurrency } from 'utils';
import { Box, Stack, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing/types';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { CHARGE_ROW_HEIGHT } from '../../../../constants';
import { QuoteCalcViewModel } from '../../../../api/types';
import { quoteCalcMapper } from '../../../../mappers/quoteCalcMapper';
import { QuoteChargeListingEntity, QuoteLineItemType } from '../../../../types';

interface Props {
  rowIndex: number;
  priceCalc: Nullable<QuoteCalcViewModel>;
}

export const EquipmentChargeRowTotalCell = ({ rowIndex, priceCalc }: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();
  const row = useWatch({ control, name: `bodyFields.${rowIndex}` });

  if (!row) return null;

  const { type } = row;

  const calcRow = quoteCalcMapper.findCalcRow(priceCalc, row);

  const charge = calcRow?.charge;
  const equipment = calcRow?.equipment;
  const displayedTotal = calcRow?.ownTotal ?? charge?.price?.total ?? equipment?.price?.total ?? null;

  const renderCellContentByType: Record<QuoteLineItemType, any> = {
    [QuoteLineItemType.Invoice]: (
      <RenderWithCondition condition={!!charge}>
        <Typography>{formatCurrency(displayedTotal, true)}</Typography>
      </RenderWithCondition>
    ),
    [QuoteLineItemType.Equipment]: (
      <Stack width="100%" height="100%" justifyContent="flex-end" gap="0.5rem">
        <Box height="100%">
          <Typography>{formatCurrency(displayedTotal, true)}</Typography>
        </Box>

        <RenderWithCondition condition={!!equipment?.attachments}>
          {equipment?.attachments.map((attachment, index) => (
            <Box key={index} minHeight={CHARGE_ROW_HEIGHT}>
              <Typography>{formatCurrency(attachment?.price?.total ?? null, true)}</Typography>
            </Box>
          ))}
        </RenderWithCondition>
      </Stack>
    ),
  };

  return <>{renderCellContentByType[type]}</>;
};
